import { VIEWINGS_DISPATCH_GUARD } from "@/config/appConfig";
import { AuthSessionProvider } from "@/contexts/AuthSessionContext";
import { LanguageProvider, useLanguage } from "@/contexts/LanguageContext";
import { getLocaleMessages } from "@/i18n/messages";
import HardNotFoundPage from "@/pages/NotFound/HardNotFoundPage";
import { IntlProvider } from "react-intl";
import { Outlet } from "react-router-dom";

function AppContent() {
  const { language } = useLanguage();
  const { locale, messages } = getLocaleMessages(language);

  if (!VIEWINGS_DISPATCH_GUARD.enabled) {
    return <HardNotFoundPage />;
  }

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <AuthSessionProvider>
        <Outlet />
      </AuthSessionProvider>
    </IntlProvider>
  );
}

export function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}
